import { render, staticRenderFns } from "./detail-transaction.vue?vue&type=template&id=d4bd87d2&"
import script from "./detail-transaction.vue?vue&type=script&lang=js&"
export * from "./detail-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports